import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { CheckCircle, ArrowRight, BookOpen } from 'lucide-react';

const PaymentReceived = () => {
  const location = useLocation();
  const { packageType, amount } = location.state || {};

  const isEnrollmentOnly = packageType === 'enrollment';
  const includesCourse = packageType && packageType !== 'enrollment';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-25 to-indigo-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full p-8">
        <div className="text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-800 mb-4">
            Payment Confirmation Received!
          </h1>
          
          <p className="text-lg text-slate-600 mb-6">
            Thank you! Your payment confirmation has been submitted successfully.
          </p>

          {amount && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-slate-600">Confirmed Amount</p>
              <p className="text-3xl font-bold text-blue-700">£{amount}</p>
            </div>
          )}

          <div className="bg-slate-50 rounded-lg p-6 mb-8 text-left">
            <h2 className="font-semibold text-slate-800 mb-4">What Happens Next?</h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-slate-700">
                  Our team will review your payment confirmation within 24 hours
                </span>
              </li>
              <li className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-slate-700">
                  You'll receive an email confirmation once verified
                </span>
              </li>
              {isEnrollmentOnly && (
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">
                    <strong>You can now select your course!</strong> Access is available immediately
                  </span>
                </li>
              )}
              {includesCourse && (
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                  <span className="text-slate-700">
                    Course access will be activated once your payment is verified
                  </span>
                </li>
              )}
            </ul>
          </div>

          <div className="space-y-3">
            {isEnrollmentOnly && (
              <Link to="/student-dashboard">
                <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4">
                  <BookOpen className="w-5 h-5 mr-2" />
                  Select Your Course Now
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            )}
            
            <Link to="/student-dashboard">
              <Button 
                variant={isEnrollmentOnly ? "outline" : "default"}
                className={`w-full font-semibold py-4 ${!isEnrollmentOnly ? 'bg-blue-600 hover:bg-blue-700 text-white' : ''}`}
              >
                Go to Student Dashboard
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>

            <Link to="/">
              <Button variant="outline" className="w-full">
                Return to Home
              </Button>
            </Link>
          </div>

          <div className="mt-8 text-sm text-slate-600">
            <p>Questions about your payment?</p>
            <Link to="/support" className="text-blue-600 hover:text-blue-700 hover:underline font-medium">
              Contact Support →
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaymentReceived;
